import { useEffect, useState } from 'react';

export const DEFAULT_LOADING_DELAY_MS = 300;

/**
 * Ensures loading state is shown for a minimum duration to prevent flickering.
 * Starts with loading visible, then delays hiding it when data finishes loading.
 *
 * @param isLoading - The actual loading state from data fetching
 * @param delay - Minimum milliseconds to keep loading visible after data loads
 * @returns boolean - Whether to show the loading UI
 */
export const useDelayedLoading = (
  isLoading: boolean,
  delay = DEFAULT_LOADING_DELAY_MS,
): boolean => {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (isLoading) {
      setShowLoading(true);
      return;
    }

    const timer = setTimeout(() => {
      setShowLoading(false);
    }, delay);

    return (): void => {
      clearTimeout(timer);
    };
  }, [isLoading, delay]);

  return showLoading;
};
